import { SupportService } from './../../../data/repository/support-repository/support.service';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from './../../../data/repository/setting-repository/setting.service';
import { Component, OnInit } from '@angular/core';
import { FaqSubCategoryListResponce } from 'src/app/core/model/api-response/support-responce.model';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  faqTitle: string = '';
  faqId: string;
  faqs: FaqSubCategoryListResponce;
  constructor(
    private settingService: SettingService,
    private route: ActivatedRoute,
    private supportService: SupportService
  ) {
    this.faqId = this.route.snapshot.paramMap.get('faqId');
  }

  ngOnInit() {
    if (this.faqId) {
      this.supportService.getFaqSubCategories(this.faqId).then((res) => {
        this.faqTitle = res
          .getData()
          .getFaqSubCategories().faqs[0].subcategory.name;

        this.faqs = res.getData().getFaqSubCategories();

        // .faqs.map((faq) => {
        //   return {
        //     title: faq.question,
        //     answer: {
        //       name: faq.answer,
        //       id: faq._id,
        //     },
        //   };
        // });
      });
    }
  }
  goToAnswer(id: string) {
    this.settingService.goToAnswer(id);
  }
  back() {
    this.settingService.goBack();
  }
}
